import { Col, Row } from "antd";
import classNames from "classnames";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import HelpYellow from "shared/components/SVG/LMF/HelpYellow";
import SocialSecurity from "shared/components/SVG/LMF/SocialSecurity";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import CustomModal from "../Components/CustomModal";
import Head from "../Components/Head";
import InfoBox from "../Components/InfoBox";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import InputChecked from "../Components/svg/check_small.svg";
import InputError from "../Components/svg/error.svg";
import { GenerateSocialSecurityNumber } from "./GenerateSocialSecurityNumber";
import validation from "./validation";

const View = ({ project, locked, onNext, onBack }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.SOCIAL_SECURITY_NUMBER", {
    returnObjects: true,
  });
  const [open, setOpen] = useState(false);
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      contact: {
        ...get(project, "contact"),
        id: get(project, "contact.id"),
        socialSecurityNumber:
          get(project, "contact.socialSecurityNumber") ||
          GenerateSocialSecurityNumber(project),
        fields: {
          ...get(project, "contact.fields"),
          teletransmission: get(
            project,
            "contact.fields.teletransmission",
            true,
          ),
        },
      },
    },
    onSubmit: onNext,
    enableReinitialize: true,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <CustomModal
        open={open}
        setOpen={setOpen}
        title={TRANSLATION.MODAL_INFO.TITLE}
        TRANSLATION={TRANSLATION}
        width={400}
        closeText={TRANSLATION.MODAL_INFO.CLOSE}
      >
        <ul className="lmf__list">
          <li>
            <span>{TRANSLATION.MODAL_INFO.OPTIONS.OPT_1}</span>
          </li>
          <li>
            <span>{TRANSLATION.MODAL_INFO.OPTIONS.OPT_2}</span>
          </li>
          <li>
            <span>{TRANSLATION.MODAL_INFO.OPTIONS.OPT_3}</span>
          </li>
        </ul>
      </CustomModal>

      <Layout>
        <Head
          description={TRANSLATION.DESCRIPTION}
          title={TRANSLATION.TITLE}
          onBack={onBack}
        />

        <div className="__LMF--content LMF-content lmf__form">
          <Row gutter={[16, 16]} justify={"center"}>
            <Col xs={24} md={18} lg={16}>
              <Input
                label={TRANSLATION.FORM.LABEL}
                placeholder={TRANSLATION.FORM.PLACEHOLDER}
                trim={true}
                className={classNames({
                  valid:
                    get(values, "contact.socialSecurityNumber") &&
                    get(values, "contact.socialSecurityNumber").length >= 5,
                })}
                {...bindInputProps({
                  name: "contact.socialSecurityNumber",
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                suffix={
                  get(formProps.errors, `contact.socialSecurityNumber`) ? (
                    <img src={InputError} alt="" />
                  ) : (
                    get(values, "contact.socialSecurityNumber") &&
                    get(values, "contact.socialSecurityNumber").length >= 5 && (
                      <img src={InputChecked} alt="" />
                    )
                  )
                }
                disabled={locked}
              />
            </Col>
            <Col xs={24} md={18} lg={16}>
              <div className="d-flex">
                <Input
                  type="checkbox"
                  label={TRANSLATION.OPT}
                  checked={
                    !get(values, "contact.fields.teletransmission", false)
                  }
                  {...bindInputProps({
                    name: "contact.fields.teletransmission",
                    values,
                    ...formProps,
                  })}
                  onChange={({ target: { checked } }) => {
                    setFieldValue("contact.fields.teletransmission", !checked);
                  }}
                  disabled={locked}
                />
                <HelpYellow size={32} onClick={() => setOpen(true)} />
              </div>
            </Col>
            <Col xs={24} md={18} lg={16}>
              <InfoBox
                variant="warning"
                text={TRANSLATION.CAPTION}
                icon={<SocialSecurity size={48} />}
              />
            </Col>
          </Row>
        </div>
        <ActionButtons
          disabled={!isEmpty(formProps.errors)}
          onNext={handleSubmit}
          buttonText={TRANSLATION.NEXT}
          {...(isMobile && { onBack })}
          className={classNames({
            "w-100": isMobile,
          })}
        />
      </Layout>
    </>
  );
};

export default View;
